export const PDF_MAX_BYTES = 1024 * 1024;
export const PDF_ALLOWED_TYPES = ["application/pdf"];

export function validatePdfUploadFile(file, fieldLabel = "File") {
  if (!file) {
    return { valid: false, message: `${fieldLabel} is required.` };
  }

  if (!PDF_ALLOWED_TYPES.includes(file.type)) {
    return { valid: false, message: "Only PDF files are allowed." };
  }

  if (file.size > PDF_MAX_BYTES) {
    return { valid: false, message: "PDF file size must not exceed 1 MB." };
  }

  return { valid: true, message: "" };
}

export const DISCHARGE_PDF_MAX_BYTES = PDF_MAX_BYTES;
export const DISCHARGE_PDF_ALLOWED_TYPES = PDF_ALLOWED_TYPES;

export function hasNewDischargePdfFile(dischargePdf) {
  return dischargePdf instanceof File;
}

export function validateDischargePdfFile(file) {
  return validatePdfUploadFile(file, "Discharge/Retirement Book");
}

export function validateExperiencePdfFile(file) {
  return validatePdfUploadFile(file, "Experience document");
}

export function validateDischargePdfStep({
  dischargePdf,
  savedDischargeDoc,
  isReplacingDischargeDoc,
}) {
  const hasNewFile = hasNewDischargePdfFile(dischargePdf);
  const hasSavedDoc = Boolean(savedDischargeDoc);

  if (isReplacingDischargeDoc) {
    if (!hasNewFile) {
      return {
        valid: false,
        message: "Please select a PDF file to replace the existing document.",
      };
    }
    return validateDischargePdfFile(dischargePdf);
  }

  if (!hasNewFile && !hasSavedDoc) {
    return { valid: false, message: "Discharge/Retirement Book is required." };
  }

  if (hasNewFile) {
    return validateDischargePdfFile(dischargePdf);
  }

  return { valid: true, message: "" };
}

export function appendDischargePdfToFormData(formData, submitData) {
  if (hasNewDischargePdfFile(formData?.dischargePdf)) {
    submitData.append("dischargePdf", formData.dischargePdf);
  }
}
